import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LoginLogo from "../../assets/showcasaai2.png";
import './Header.css';
import { Button, Chip, CardContent, Divider, Popover } from '@mui/material';
import DiamondIcon from "@mui/icons-material/Diamond";
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreditPoints, } from '../../services/CreditPointsProvider';
import { showToast } from "../Toast/CommonToast";
import { logout } from "../../services/apiService";
import { Link } from "react-router-dom";

const navLinks = [
    { name: 'Home', href: '/home' },
    { name: 'Personas', href: '/personas' },
    { name: 'Studio', href: '/studio' },
    { name: 'Ideaboard', href: '/idea-board' },
    { name: 'Library', href: '/library' },
];

const ideaBoardMenu = [
    { name: 'Cartoon', href: '/idea-board/cartoon', icon: '/assets/Cartoon.svg' },
    { name: 'ProductScape', href: '/idea-board/productscape', icon: '/assets/ProductPos.svg' },
];

const studioMenu = [
    { name: 'Cinemotion', href: '/studio/cinemotion', icon: '/assets/Cinemotion.svg' }, 
    { name: 'Phototalks', href: '/studio/photo-talks', icon: '/assets/PhotoTalks.svg' }, 
    { name: 'Podcast', href: '/studio/podcast', icon: '/assets/P2.svg' }, 
    { name: 'RampWalk', href: '/studio/rampwalk', icon: '/assets/RampWalk.png' },
    { name: 'Reels', href: '/studio/reels', icon: '/assets/ReelsHeader.svg' }, 
    { name: 'Shortfilms', href: '/studio/comingsoon', icon: '/assets/ComingSoon.svg' }, 
];

const Header: React.FC = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [ideaBoardAnchorEl, setIdeaBoardAnchorEl] = useState<null | HTMLElement>(null);
    const [mobileIdeaBoardAnchorEl, setMobileIdeaBoardAnchorEl] = useState<null | HTMLElement>(null);
    const [studioAnchorEl, setStudioAnchorEl] = useState<null | HTMLElement>(null);
    const [mobileStudioAnchorEl, setMobileStudioAnchorEl] = useState<null | HTMLElement>(null);
    const [popoverAnchorEl, setPopoverAnchorEl] = useState<null | HTMLElement>(null);
    const { creditPoints, fetchCreditPoints } = useCreditPoints();
    const isVerified = localStorage.getItem("isVerified");
    const location = useLocation();
    const navigate = useNavigate();
    const name = localStorage.getItem("name");
    const email = localStorage.getItem("email") || "";
    let initialsAvatar = "U";
    let avatarName = "User";
    if (name && name !== "undefined" && name.trim() !== "") {
        initialsAvatar = name.charAt(0).toUpperCase();
        avatarName = name.charAt(0).toUpperCase() + name.slice(1);
    } else if (email && email.includes("@")) {
        const emailPrefix = email.split("@")[0];
        initialsAvatar = emailPrefix.charAt(0).toUpperCase();
        avatarName = emailPrefix.charAt(0).toUpperCase() + emailPrefix.slice(1);
    }
    const userId = localStorage.getItem("userId");

    useEffect(() => {
  // fetch data or reset state here
  console.log("Header component mounted or location changed");
  console.log("Current path:", location.pathname);
}, [location.pathname]);
    const handleDrawerToggle = () => setDrawerOpen((prev) => !prev);
    
    // Ideaboard Menu handlers
    const handleIdeaBoardMenuOpen = (event: React.MouseEvent<HTMLElement>) => setIdeaBoardAnchorEl(event.currentTarget);
    const handleIdeaBoardMenuClose = () => setIdeaBoardAnchorEl(null);
    
    // Studio Menu handlers
    const handleStudioMenuOpen = (event: React.MouseEvent<HTMLElement>) => setStudioAnchorEl(event.currentTarget);
    const handleStudioMenuClose = () => setStudioAnchorEl(null);
    
    // Mobile Menu handlers
    const handleMobileIdeaBoardMenuOpen = (event: React.MouseEvent<HTMLElement>) => setMobileIdeaBoardAnchorEl(event.currentTarget);
    const handleMobileIdeaBoardMenuClose = () => setMobileIdeaBoardAnchorEl(null);
    
    const handleMobileStudioMenuOpen = (event: React.MouseEvent<HTMLElement>) => setMobileStudioAnchorEl(event.currentTarget);
    const handleMobileStudioMenuClose = () => setMobileStudioAnchorEl(null);
    
    // Popover handlers
    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setPopoverAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setPopoverAnchorEl(null);
    };
    const popoverOpen = Boolean(popoverAnchorEl);

    const handleByCredits = () => {
        localStorage.setItem("redirectLocation", location.pathname);
        navigate("/subscription")
    }
    useEffect(() => {
        fetchCreditPoints(userId);
    }, [userId, fetchCreditPoints]);

    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    const handleLogout = async () => {
        const response = await logout(accessToken, refreshToken);
        if (response.status === "true") {
            localStorage.clear();
            navigate("/login");
            showToast("Logged out successfully", "success");
        } else {
            localStorage.clear();
            navigate("/login");
            showToast("Logged out successfully", "success");
        }
    }

    const isActive = (href: string) =>
        location.pathname === href ||
        (href === '/idea-board' && location.pathname.startsWith('/idea-board')) ||
        (href === '/personas' && (location.pathname.startsWith('/humanpersona/model/') || (location.pathname.startsWith('/aipersona/model/') || location.pathname.startsWith('/persona/add-model')))) ||
        (href === '/studio' && location.pathname.startsWith('/studio'))

    // Helper for instant navigation
    const handleIdeaBoardNav = () => {
        if (drawerOpen) setDrawerOpen(false);
        navigate('/idea-board', { replace: true });
    };

    const handleStudioNav = () => {
        if (drawerOpen) setDrawerOpen(false);
        navigate('/studio', { replace: true });
    };

    return (
        <AppBar position="sticky" color="default" elevation={1} sx={{
            backgroundColor: '#2D3157 !important',
            borderBottom : '1px solid rgba(255, 255, 255, 0.2)'}}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', px: 2 }}>
                <Box className="logoContainer" onClick={() => window.location.href = '/home'}>
                    <img src={'/assets/showcasaNew.svg'} alt="logo" className="logoImage" />
                </Box>
                <Box className="navLinksContainer">
                    {navLinks.map((link) => {
                        if (link.name === 'Ideaboard') {
                            return (
                                <Box key={link.name} className="ideaBoardBox">
                                    <Typography
                                        aria-controls="idea-board-menu"
                                        aria-haspopup="true"
                                        onClick={handleIdeaBoardNav}
                                        className={`ideaBoardMenuLabel${isActive(link.href) ? ' active' : ''}`}
                                        style={{cursor: 'pointer'}}
                                      
                                    >
                                        {link.name}
                                        <Chip label="New" className="chipstyle" size="small" />
                                        <span
                                            onClick={e => { e.stopPropagation(); handleIdeaBoardMenuOpen(e as any); }}
                                            className='menuLabel'
                                        >
                                            <KeyboardArrowDownIcon fontSize="small" className="arrowDownIcon" />
                                        </span>
                                    </Typography>
                                    <Menu
                                        id="idea-board-menu"
                                        anchorEl={ideaBoardAnchorEl}
                                        open={Boolean(ideaBoardAnchorEl)}
                                        onClose={handleIdeaBoardMenuClose}
                                        MenuListProps={{ 'aria-labelledby': 'idea-board-button' }}
                                        className='ideaBoardMenu'
                                    >
                                        {ideaBoardMenu.map((item) => (
                                            <MenuItem key={item.name} onClick={handleIdeaBoardMenuClose} component={Link} to={item.href} className='ideaMenuItem'>
                                                <img src={item.icon} alt={item.name + ' Icon'} className="ideaMenuIcon" />
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>
                            );
                        } else if (link.name === 'Studio') {
                            return (
                                <Box key={link.name} className="ideaBoardBox">
                                    <Typography
                                        aria-controls="studio-menu"
                                        aria-haspopup="true"
                                        onClick={handleStudioNav}
                                        className={`ideaBoardMenuLabel${isActive(link.href) ? ' active' : ''}`}
                                    >
                                        {link.name}
                                        <Chip label="New" className="chipstyle" size="small" />
                                        <span
                                            onClick={e => { e.stopPropagation(); handleStudioMenuOpen(e as any); }}
                                            className='menuLabel'
                                        >
                                            <KeyboardArrowDownIcon fontSize="small" className="arrowDownIcon" />
                                        </span>
                                    </Typography>
                                    <Menu
                                        id="studio-menu"
                                        anchorEl={studioAnchorEl}
                                        open={Boolean(studioAnchorEl)}
                                        onClose={handleStudioMenuClose}
                                        MenuListProps={{ 'aria-labelledby': 'studio-button' }}
                                        className='studioMenu'
                                    >
                                        {studioMenu.map((item) => (
                                            <MenuItem
                                                key={item.name}
                                                component={Link}
                                                to={item.href}
                                                onClick={handleStudioMenuClose}
                                                className="ideaMenuItem"
                                            >
                                                <img src={item.icon} alt={item.name + ' Icon'} className="podcastIcon" />
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>
                            );
                        } else {
                            return (
                                <Typography
                                    key={link.name}
                                 component={Link} to={link.href}
                                    className={`navLink${isActive(link.href) ? ' active' : ''}`}
                                    style={{cursor: 'pointer'}}
                                >
                                    {link.name}
                                </Typography>
                            );
                        }
                    })}
                </Box>
                <Box className="headerRight">
                    <Button disabled={isVerified === 'false'} onClick={handleByCredits} startIcon={<DiamondIcon className="diamondIcon" />} className="buyCreditsButton">
                        {creditPoints && creditPoints > 0 ? (
                            <div className="credit-box">
                                <Typography className="credit-price">
                                    {creditPoints} Credits
                                </Typography>
                                <Typography className="credit-upgrade">
                                    Buy Credits
                                </Typography>
                            </div>
                        ) : (
                            <Typography className="buyCreditsText">
                                Buy Credits
                            </Typography>
                        )}
                    </Button>
                    <IconButton onClick={handleOpen}>
                        <Avatar className="avatar">{initialsAvatar}</Avatar>
                    </IconButton>
                    <IconButton
                        color="inherit"
                        edge="end"
                        onClick={handleDrawerToggle}
                        className="drawerToggleBtn"
                        aria-label="open drawer"
                    >
                        <MenuIcon />
                    </IconButton>
                </Box>
            </Toolbar>
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleDrawerToggle}
                className="drawer"
                PaperProps={{ className: 'drawerPaper' }}
            >
                <Box className="drawerHeader">
                     <Box className="logoContainer" onClick={() => window.location.href = '/home'}>
                    <img src={'/assets/showcasaNew.svg'} alt="logo" className="logoImage" />
                </Box>
                    <IconButton onClick={handleDrawerToggle} className="drawerCloseBtn">
                        <CloseIcon />
                    </IconButton>
                </Box>
                <List>
                    {navLinks.map((link) => {
                        if (link.name === 'Ideaboard') {
                            return (
                                <Box key={link.name} className="ideaBoardBox">
                                    <ListItem disablePadding>
                                        <Typography
                                            aria-controls="idea-board-menu-mobile"
                                            aria-haspopup="true"
                                            onClick={handleIdeaBoardNav}
                                            className={`ideaBoardMenuLabel${isActive(link.href) ? ' active' : ''}`}
                                            style={{ width: '100%' }}
                                        >
                                            {link.name}
                                            <Chip label="New" className="chipstyle" size="small" />
                                            <span
                                                onClick={e => { e.stopPropagation(); handleMobileIdeaBoardMenuOpen(e as any); }}
                                                className='menuLabel'
                                            >
                                                <KeyboardArrowDownIcon fontSize="small" className="arrowDownIcon" />
                                            </span>
                                        </Typography>
                                    </ListItem>
                                    <Menu
                                        id="idea-board-menu-mobile"
                                        anchorEl={mobileIdeaBoardAnchorEl}
                                        open={Boolean(mobileIdeaBoardAnchorEl)}
                                        onClose={handleMobileIdeaBoardMenuClose}
                                        MenuListProps={{ 'aria-labelledby': 'idea-board-button-mobile' }}
                                        className='ideaBoardMenu'
                                    >
                                        {ideaBoardMenu.map((item) => (
                                            <MenuItem 
                                                key={item.name} 
                                                onClick={handleMobileIdeaBoardMenuClose} 
                                                component={Link} 
                                                to={item.href} 
                                                className='ideaMenuItem'
                                            >
                                                <img src={item.icon} alt={item.name + ' Icon'} className="ideaMenuIcon" />
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>
                            );
                        } else if (link.name === 'Studio') {
                            return (
                                <Box key={link.name} className="ideaBoardBox">
                                    <ListItem disablePadding>
                                        <Typography
                                            aria-controls="studio-menu-mobile"
                                            aria-haspopup="true"
                                            onClick={handleStudioNav}
                                            className={`ideaBoardMenuLabel${isActive(link.href) ? ' active' : ''}`}
                                            style={{ width: '100%' }}
                                        >
                                            {link.name}
                                            <Chip label="New" className="chipstyle" size="small" />
                                            <span
                                                onClick={e => { e.stopPropagation(); handleMobileStudioMenuOpen(e as any); }}
                                                className='menuLabel'
                                            >
                                                <KeyboardArrowDownIcon fontSize="small" className="arrowDownIcon" />
                                            </span>
                                        </Typography>
                                    </ListItem>
                                    <Menu
                                        id="studio-menu-mobile"
                                        anchorEl={mobileStudioAnchorEl}
                                        open={Boolean(mobileStudioAnchorEl)}
                                        onClose={handleMobileStudioMenuClose}
                                        MenuListProps={{ 'aria-labelledby': 'studio-button-mobile' }}
                                        className='studioMenu'
                                    >
                                        {studioMenu.map((item) => (
                                            <MenuItem
                                                key={item.name}
                                                component={Link}
                                                to={item.href}
                                                onClick={handleStudioMenuClose}
                                                className="ideaMenuItem"
                                            >
                                                <img src={item.icon} alt={item.name + ' Icon'} className="podcastIcon" />
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>
                            );
                        } else {
                            return (
                                <ListItem key={link.name} disablePadding>
                                    <Typography
                                        component={Link} 
                                        to={link.href}
                                        className={`navLink${isActive(link.href) ? ' active' : ''}`}
                                        style={{ cursor: 'pointer', width: '100%' }}
                                        onClick={handleDrawerToggle}
                                    >
                                        {link.name}
                                    </Typography>
                                </ListItem>
                            );
                        }
                    })}
                </List>
            </Drawer>
            <Popover
                open={popoverOpen}
                anchorEl={popoverAnchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{ className: 'popoverCard' }}
            >
                <CardContent className="popoverContent">
                    <Box className="popover-avatarContainer">
                        <Box>
                            <Typography className="emailText" variant="h6">
                                {avatarName}
                            </Typography>
                            <Typography className="emailtextSpan" variant="body1">
                                {email}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider className="divider" />
                    <Box className="profileBox">
                         <Typography
                            className="profileText"
                            variant="body1"
                            onClick={() => { handleClose(); navigate("/settings"); }}
                        >
                            Settings
                        </Typography>
                        <Typography
                            className="profileTextLogout"
                            variant="body1"
                            onClick={() => { handleClose(); handleLogout(); }}
                            style={{cursor: 'pointer'}}
                        >
                            Logout
                        </Typography>
                    </Box>
                </CardContent>
            </Popover>
        </AppBar>
    );
};

export default Header;